import { render } from "./ProductStatistical.vue?vue&type=template&id=27905232&scoped=true"
import script from "./ProductStatistical.vue?vue&type=script&lang=js"
export * from "./ProductStatistical.vue?vue&type=script&lang=js"

import "./ProductStatistical.vue?vue&type=style&index=0&id=27905232&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27905232"]])

export default __exports__